<template>
  <div class="x-button">
    <el-button :class="loading?'x-flex x-row-center':''" :style="{
      'background-color': bgc,
      'color':color ,
      'border':border,
      'width':width,
      'height':height,
      'margin-left':margin_left,
      'margin-right':margin_right
    }" :loading='loading' :disabled='disabled'>
      <div>{{title}}</div>
      <slot></slot>
    </el-button>
  </div>
</template>

<script>
  export default {
    props: {
      loading: {
        type: [Boolean],
        default: false,
      },
      disabled: {
        type: [Boolean],
        default: false,
      },
      title: {
        type: [String],
        default: "",
      },
      bgc: {
        type: [String],
        default: "#FF5A32",
      },
      color: {
        type: [String],
        default: "#FFFFFF",
      },
      border: {
        type: [String],
        default: "1px solid #FF5A32",
      },
      width: {
        type: [String],
        default: "90px",
      },
      height: {
        type: [String],
        default: "32px",
      },
      margin_left: {
        type: [String],
        default: "0px",
      },
      margin_right: {
        type: [String],
        default: "0px",
      },
    }
  }
</script>

<style lang="less" scoped>
  .x-button {
    font-size: 14px;

    // border-radius: 4px;
    /deep/.el-button {
      padding: 0px;
      margin-left: ;
      margin-right: ;
    }

    &:hover {
      cursor: pointer;
    }

    &:active {
      opacity: 0.5;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/xButton.vue